import React, { useEffect, useRef } from "react";
import "./RectangleGenerator.css";

const RectangleGenerator = ({ width, height, typeOfMediaName }) => {
  const rectRef = useRef(null);

  useEffect(() => {
    const rect = rectRef.current;
    if (rect) {
      let rectWidth = rect.offsetWidth;
      rect.style.left = `calc(100% + ${rectWidth / 2}px)`;
    }
  }, []);

  // Calculate scaling factor based on the maximum dimension
  const maxDimension = Math.max(width, height);
  const scaleFactor = maxDimension > 10 ? 20 / maxDimension : 2; // Adjust this as needed
  const areaUnit = typeOfMediaName === "Magazine" ? "sqIn" : "sqFt";

  return (
    <div className="rectangle-generator-container">
      <div
        className="rectangle-generator-parent"
        style={{ width: `${width * scaleFactor}rem`, height: `${height * scaleFactor}rem` }}
      >
        <div className="rectangle-area">
          {width * height} {areaUnit}
        </div>
        <div className="rectangle-width">{width} W</div>
        <div className="rectangle-height" ref={rectRef}>
          {height} H
        </div>
      </div>
    </div>
  );
};

export default RectangleGenerator;
